import { useCurrentWorkspace } from 'src/store';

export const useBrandVoices = () => {
  const currentWorkspace = useCurrentWorkspace();

  return currentWorkspace?.associatedBrandVoices || [];
};
